export function isNilOrEmpty(value) {
  return value == null || value.length === 0
}
